import PropTypes from 'prop-types';
import { ModalCustom } from '$src/components/Modal';
import { InfoOutlineIcon } from '@ring-icons';

import './index.less';

const AUTHORIZE_GUARD_STRINGS = {
  TITLE: 'Confirm',
  HEADER: 'Default to this Private Guard for emergency dispatches?',
  MESSAGE: 'Agents will request emergency dispatches from your private security service instead of local police.',
  CONFIRM_BUTTON: 'Confirm',
  CANCEL_BUTTON: 'Cancel'
};

export default function AuthorizeOwnGuardDialog({ showModal, handleAuthorize, handleCancel, ...rest }) {
  return (
    <ModalCustom
      title={AUTHORIZE_GUARD_STRINGS.TITLE}
      data-testid="authorize-own-guard-dialog"
      contentTitle={
        <>
          <InfoOutlineIcon width="42px"  className="authorize-own-guard-dialog__content-title__icon" />
          <h2>{AUTHORIZE_GUARD_STRINGS.HEADER}</h2>
        </>
      }
      width="650px"
      contentMessage={AUTHORIZE_GUARD_STRINGS.MESSAGE}
      visible={showModal}
      handleOk={handleAuthorize}
      okText={AUTHORIZE_GUARD_STRINGS.CONFIRM_BUTTON}
      cancelText={AUTHORIZE_GUARD_STRINGS.CANCEL_BUTTON}
      {...rest}
    />
  );
}

AuthorizeOwnGuardDialog.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleAuthorize: PropTypes.func,
  handleCancel: PropTypes.func,
};
